import { reactive, nextTick } from 'vue'
import { StoreBase } from '../StoreBase'

class MessageDialogStore implements StoreBase {
  /* eslint-disable class-methods-use-this */
  createStore() {
    const state = reactive({
      isVisible: false,
      title: '',
      message: '',
      htmlMessage: '',
      // 'notice'  通知
      // 'caution' 注意
      // 'error'   エラー
      status: '',
      cancelButton: false,
    })

    let resolver: ((result: 'OK' | 'Cancel') => void) | null = null

    /**
     * ダイアログ表示に必要な項目を設定する
     * @param title ダイアログタイトル
     * @param message ダイアログメッセージ
     * @param status ダイアログステータス default=通知
     * @param cancelButton キャンセルボタン表示有無 default=非表示
     */
    const setConfig = ({
      title = '',
      message = '',
      htmlMessage = '',
      status = 'notice',
      cancelButton = false,
    }) => {
      state.title = title
      state.message = message
      state.htmlMessage = htmlMessage
      state.status = status
      state.cancelButton = cancelButton
    }

    /**
     * ダイアログを表示する
     * 先にダイアログの設定をしてから、ダイアログを開く場合に使用。
     * マニュアルダイアログオープン
     */
    const open = (): Promise<'OK' | 'Cancel' | 'CanNotOpen'> => {
      if (resolver) {
        return Promise.resolve('CanNotOpen')
      }
      return new Promise(resolve => {
        state.isVisible = true
        resolver = msg => resolve(msg)
      })
    }

    /**
     * ダイアログを表示する
     * @param title ダイアログタイトル
     * @param message ダイアログメッセージ
     * @param status ダイアログステータス default=通知
     * @param cancelButton キャンセルボタン表示有無 default=非表示
     */
    const openWithSettings = ({
      title = '',
      message = '',
      htmlMessage = '',
      status = 'notice',
      cancelButton = false,
    }) => {
      setConfig({ title, message, htmlMessage, status, cancelButton })
      const result = open()
      return result
    }

    /**
     * ダイアログを閉じる
     */
    const close = async (btn: 'OK' | 'Cancel') => {
      state.isVisible = false
      await nextTick()
      if (resolver) {
        resolver(btn)
      }
      resolver = null
    }

    return {
      open,
      openWithSettings,
      close,
      setConfig,
      /**
       * 表示フラグ
       */
      get isVisible(): boolean {
        return state.isVisible
      },
      /**
       * ダイアログタイトル
       */
      get title(): string {
        return state.title
      },
      /**
       * ダイアログメッセージ
       */
      get message(): string {
        return state.message
      },
      /**
       * html メッセージ
       */
      get htmlMessage(): string {
        return state.htmlMessage
      },
      /**
       * ダイアログステータス
       */
      get status(): string {
        return state.status
      },
      /**
       * 表示フラグ
       */
      get cancelButton(): boolean {
        return state.cancelButton
      },
    }
  }
  /* eslint-enable class-methods-use-this */
}

export default new MessageDialogStore().createStore()
